import Header from './header';

export const HeaderStore = new Header();

